// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"loader_loaderContainer__b3NR_","loaderContainerArcade":"loader_loaderContainerArcade__o7ddF"};